import ShipperPriceCell from './component';
import { compose } from 'recompose';
import { connect } from 'react-redux';

import { withJourneyCardSelectors } from 'modules/journey/card/hoc';

const fields = ['currency', 'shipper_orders'];

const voidArray = [];

const enhance = compose(
  withJourneyCardSelectors,
  connect((state, props) => {
    const { currency, shipper_orders: shipperOrders } = props.selectors.getJourneyFields(
      state,
      props.journeyId,
      fields
    );

    const totalPrice = (shipperOrders || voidArray).reduce((acc, shipperOrder) => {
      return acc + Number(shipperOrder.net_full_price);
    }, 0);

    return {
      currency,
      totalPrice,
    };
  })
);

export default enhance(ShipperPriceCell);
